import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';
import Fragments from './fragments';

export const DICTIONARY_LIST_QUERY = gql`
  query dictionaries($pager: PagerInputNew, $context: ContextInput, $filters: DictionariesFilterInput) {
    dictionaries(pager: $pager, context: $context, filters: $filters) {
      total
      context {
        ...context
      }
      values {
        ...dictionary
      }
    }
  }
  ${CommonFragments.context}
  ${Fragments.dictionary}
`;
